import * as XLSX from 'xlsx'
import { getToday } from '@/utils/DateUtils'
import ExcelJS from 'exceljs'
import _ from 'lodash'
import CS from '@/utils/constants'
import { Location, Range } from '@/utils/excel'

export default {
  namespaced: true,
  actions: {
    fileRead({ state, getters, dispatch, commit }, params) {
      const fileReader = new FileReader()
      if (params.file === undefined) {
        return new Promise((resolve, reject) => {
          resolve(true)
        })
      } else {
        if (params.file.name.split('.')[1] === 'csv' || params.file.name.split('.')[1] === 'txt') {
          return new Promise((resolve, reject) => {
            let flag = 0
            fileReader.onload = e => {
              let rows = e.target.result.split('\n')
              let rowLength
              // csv, txt length
              if (params.file.name.split('.')[1] === 'csv') {
                rowLength = rows.length - 1
              } else {
                rowLength = rows.length
              }
              for (var i = 0; i < rowLength; i++) {
                let cells = rows[i].split(',')
                if (cells.length !== params.format.length) {
                  flag = 1
                  break
                }
                for (var j = 0; j < cells.length; j++) {
                  if (cells[j] === '' || cells[j] === '\r') {
                    flag = 1
                    break
                  }
                  for (var k = 0; k < params.format.length; k++) {
                    if (j === k) {
                      // isNaN 문자일때 true, 숫자알때 false
                      if (params.format[k] === 'String') {
                        if (!isNaN(cells[j])) {
                          flag = 1
                          break
                        }
                      }
                      if (params.format[k] === 'Number') {
                        if (isNaN(cells[j])) {
                          flag = 1
                          break
                        }
                      }
                    }
                  }
                }
                if (flag === 1) {
                  break
                }
              }
              if (flag) {
                resolve(false)
              } else {
                resolve(true)
              }
            }
            fileReader.readAsText(params.file)
          })
        } else {
          return new Promise((resolve, reject) => {
            let flag = 0
            fileReader.onload = e => {
              let data = e.target.result

              let workbook = XLSX.read(data, { type: 'binary' })
              workbook.SheetNames.forEach(sheetName => {
                const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])
                let worksheet = workbook.Sheets[sheetName]
                var range = { s: { c: 0, r: 1 }, e: { c: params.format.length - 1, r: excelData.length } }
                for (var R = range.s.r; R <= range.e.r; ++R) {
                  // format 개수와 cell 개수가 틀릴때
                  if (Object.keys(excelData[0]).length !== params.format.length) {
                    flag = 1
                    break
                  }
                  for (var C = range.s.c; C <= range.e.c; ++C) {
                    var celladdress = { c: C, r: R }
                    var data = XLSX.utils.encode_cell(celladdress)
                    for (var k = 0; k < params.format.length; k++) {
                      // data 체크
                      if (worksheet[data] === undefined || worksheet[data] === '') {
                        flag = 1
                        break
                      }
                      // cell index와 format index 같을 때 data format 체크
                      if (C === k) {
                        // isNaN 문자일때 true, 숫자알때 false
                        if (params.format[k] === 'String') {
                          if (!isNaN(worksheet[data].v)) {
                            // console.log('String #### worksheet[data]-->', worksheet[data].v)
                            flag = 1
                            break
                          }
                        }
                        if (params.format[k] === 'Number') {
                          if (isNaN(worksheet[data].v)) {
                            // console.log('Number #### worksheet[data]-->', worksheet[data].v)
                            flag = 1
                            break
                          }
                        }
                      }
                    }
                  }
                }
                if (flag) {
                  resolve(false)
                } else {
                  resolve(true)
                }
              })
            }
            fileReader.readAsBinaryString(params.file)
          })
        }
      }
    },
    couponReportDownloadExcel({ state, getters, dispatch, commit }, params) {
      let wb = XLSX.utils.book_new() // 새 시트 생성
      let ws = XLSX.utils.json_to_sheet([params.excelHeaders], { skipHeader: true }) // 헤더 명

      let excelDatas = []
      params.excelData.forEach((data, dataIndex) => {
        let excelData = {}
        Object.keys(params.excelHeaders).forEach(key => {
          if (data[key] === null) {
            excelData[key] = ''
          } else {
            if (params.excelDataType[key] === 'numeric') {
              excelData[key] = parseFloat(data[key])
            } else {
              excelData[key] = data[key]
            }
          }
        })
        excelDatas.push(excelData)
      })

      // public하게 사용하도록 custom이 필요함..
      // 현재는 coupon 전용임.
      XLSX.utils.sheet_add_json(ws, excelDatas, { skipHeader: true, origin: 'A2' }) // 데이터
      Object.keys(ws).forEach(key => {
        let row = key.replace(/[0-9]/g, '')
        let col = key.replace(/[A-Z]/g, '')
        if (col !== '1') {
          if (row === 'A') {
            ws[key].t = 's'
          } else if (row === 'J') {
            let discountRatio = ws[key].v / 100
            ws[key].t = 'n'
            ws[key].z = XLSX.SSF._table[9]
            ws[key].v = isNaN(discountRatio) || ws[key].v === '' ? '' : discountRatio
          } else if (row === 'O') {
            let clickRate = ws['L' + col].v === 0 ? '' : ws['N' + col].v / ws['L' + col].v
            ws[key].t = 'n'
            ws[key].z = XLSX.SSF._table[10]
            ws[key].v = isNaN(clickRate) ? '' : clickRate
          } else if (row === 'Q') {
            ws[key].t = 'n'
            ws[key].z = XLSX.SSF._table[10]
          } else if (row === 'V') {
            let productPurchaseRate = ws['L' + col].v === 0 ? '' : ws['U' + col].v / ws['L' + col].v
            ws[key].t = 'n'
            ws[key].z = XLSX.SSF._table[10]
            ws[key].v = isNaN(productPurchaseRate) ? '' : productPurchaseRate
          } else {
            if (ws[key].t === 'n') {
              ws[key].z = XLSX.SSF._table[3]
            }
          }
        }
      })
      ws['!cols'] = params.excelCellStyle
      XLSX.utils.book_append_sheet(wb, ws, '쿠폰 리포트') // 시트 명명, 데이터 지정
      XLSX.writeFile(wb, '쿠폰 리포트' + getToday() + '.xlsx') // 엑셀파일 만듬
    },
    downloadExcel({ state, getters, dispatch, commit }, params) {
      if (params.menu === 'slide') {
        downloadExcelRCSSlide(params)
      } else if (params.menu === 'template') {
        // slide 제외 템플릿 엑셀 다운로드
        downloadExcelTemplate(params)
      } else if (params.menu === 'styledExcel') {
        downloadExcelWithStyle(params)
      } else {
        let wb = XLSX.utils.book_new() // 새 시트 생성
        let ws = XLSX.utils.json_to_sheet([params.excelHeaders], { skipHeader: true }) // 헤더 명

        let excelDatas = []
        params.excelData.forEach((data, dataIndex) => {
          let excelData = {}
          Object.keys(params.excelHeaders).forEach(key => {
            if (params.excelDataType[key] === 'numeric') {
              excelData[key] = parseFloat(data[key])
            } else if (params.excelDataType[key] === 'array') {
              excelData[key] = data[key].toString()
            } else {
              excelData[key] = data[key]
            }
          })
          excelDatas.push(excelData)
        })
        XLSX.utils.sheet_add_json(ws, excelDatas, { skipHeader: true, origin: 'A2' }) // 데이터
        Object.keys(ws).forEach(key => {
          let col = key.replace(/[A-Z]/g, '')
          if (col !== '1') {
            if (ws[key].t === 'n') {
              ws[key].z = XLSX.SSF._table[3]
            }
          }
        })
        ws['!cols'] = params.excelCellStyle
        ws['!rows'] = params.excelRowStyle
        XLSX.utils.book_append_sheet(wb, ws, params.sheetName) // 시트 명명, 데이터 지정
        XLSX.writeFile(wb, params.fileName + '.xlsx') // 엑셀파일 만듬
      }
    },
    downloadExcelCampaign({ state, getters, dispatch, commit }, params) {
      let wb = XLSX.utils.book_new() // 새 시트 생성
      let ws = XLSX.utils.json_to_sheet([params.excelHeaders], { skipHeader: true }) // 헤더 명

      let excelDatas = []
      params.excelData.forEach((data, dataIndex) => {
        let excelData = {}
        Object.keys(params.excelHeaders).forEach(key => {
          if (params.excelDataType[key] === 'numeric') {
            excelData[key] = parseFloat(data[key])
          } else if (params.excelDataType[key] === 'array') {
            excelData[key] = data[key].toString()
          } else {
            excelData[key] = data[key]
          }
        })
        excelDatas.push(excelData)
      })
      XLSX.utils.sheet_add_json(ws, excelDatas, { skipHeader: true, origin: 'A2' }) // 데이터
      Object.keys(ws).forEach(key => {
        let col = key.replace(/[A-Z]/g, '')
        if (col !== '1') {
          if (ws[key].t === 'n') {
            ws[key].z = XLSX.SSF._table[3]
          }
        }
      })
      ws['!cols'] = params.excelCellStyle
      ws['!rows'] = params.excelRowStyle
      XLSX.utils.book_append_sheet(wb, ws, params.sheetName) // 시트 명명, 데이터 지정
      XLSX.writeFile(wb, params.fileName + '.xlsx') // 엑셀파일 만듬
    },
    async makeSingleProductMessageExcel({ state, getters, dispatch, commit }, product) {
      let excelCdnAddress = 'https://cdn-stg.tdeal.kr/admin/lmsContents/singleProductExcelSample.xlsx'
      let res = await fetch(excelCdnAddress)
      let file = await res.blob()
      const workbook = new ExcelJS.Workbook()
      workbook.xlsx
        .load(file)
        .then(workbook => {
          const sheet = workbook.getWorksheet(CS.single.sampleSheetName)
          sheet.name = product.productNo

          let imageFile = ''
          if (product.image.type === 'base64') {
            if (product.image.value.indexOf(',') !== -1) {
              product.image.value = product.image.value.split(',')[1]
            }
            imageFile = Buffer.from(product.image.value, 'base64')
          }

          workbook.media[CS.single.moldImageId].buffer = imageFile
          sheet.getCell(CS.single.messageContentCell).value = product.title + '\n\n' + product.content

          const sheet2 = workbook.getWorksheet(2)
          sheet2.name = `${product.productNo}.${product.companyContact}`
          sheet2.getCell(CS.single.companyContactCell).value = product.companyContact
          sheet2.getCell(CS.single.customerCompanyCell).value = product.customerCompany

          workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer])
            let url = window.URL.createObjectURL(blob)

            let elem = document.createElement('a')
            elem.href = url
            elem.download = `${product.fileName}.xlsx`
            elem.click()
            elem.remove()
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    async makeBundleProductMessageExcel({ state, getters, dispatch, commit }, products) {
      const sourceWorkbook = new ExcelJS.Workbook()
      const sourceFileName = CS.bundle.sampleFilePath

      const targetWorkbook = new ExcelJS.Workbook()
      const sheetName = CS.bundle.resultSheetName

      sourceWorkbook.xlsx.readFile(sourceFileName).then(workbook => {
        const sourceSheet = workbook.getWorksheet(CS.bundle.resultSheetName)
        const targetSheet = targetWorkbook.addWorksheet(sheetName)

        // 공통되는 부분
        const commonContentRange = new Range(new Location(1, 1), new Location(8, 3))
        targetSheet.mergeCells('B4:B6')
        copyCellValue(sourceSheet, targetSheet, commonContentRange, commonContentRange)
        copyCellStyle(sourceSheet, targetSheet, commonContentRange, commonContentRange)

        // 상품 부분
        const productStyleRange = new Range(new Location(1, 4), new Location(7, 6))
        const productContentRange = new Range(new Location(3, 4), new Location(3, 6))

        for (let i = 0; i < products.length; i++) {
          const targetStyleRange = new Range(new Location(1, 4 + parseInt(i * CS.bundle.cellInterval)), new Location(7, 6 + parseInt(i * CS.bundle.cellInterval)))
          const targetContentRange = new Range(new Location(3, 4 + parseInt(i * CS.bundle.cellInterval)), new Location(3, 6 + parseInt(i * CS.bundle.cellInterval)))
          copyCellStyle(sourceSheet, targetSheet, productStyleRange, targetStyleRange)
          copyCellValue(sourceSheet, targetSheet, productContentRange, targetContentRange)
          fillContent(targetSheet, products[i], i)
          fillImage(targetSheet, products[i].image, i)
        }

        workbook.xlsx.writeBuffer().then(buffer => {
          const blob = new Blob([buffer])
          let url = window.URL.createObjectURL(blob)

          let elem = document.createElement('a')
          elem.href = url
          elem.download = `묶음발송.xlsx`
          elem.click()
          elem.remove()
        })
      })
    },
    
    // 발송 미리보기 모달 엑셀 다운로드
    downloadMessagePreviewExcel(context, params) {
      return downloadExcelTemplate(params)
    },
  }
}
async function downloadExcelTemplate(params) {
  const workbook = new ExcelJS.Workbook()
  workbook.addWorksheet(params.sheetName)
  const worksheet = workbook.getWorksheet(params.sheetName)

  worksheet.columns = [
    { header: '', key: '', width: 10 },
    { header: '', key: 'col', width: 30 },
    { header: '', key: 'data', width: 55 }
  ]
  let imageIndex = []
  let cell = []
  params.contents.forEach((item, index) => {
    if (item.id === 'imageId' || item.id === 'base64Image') {
      worksheet.addRow({ col: `${item.title}`, data: '' })
      worksheet.getRow(index + 2).height = 300
      imageIndex.push(index)
      cell.push(`C${index + 2}:C${index + 2}`)
    } else {
      worksheet.addRow({ col: item.title, data: item.content })
      if (worksheet.getCell(`C${index + 2}`).value === null) {
        worksheet.getRow(index + 2).height = 40
      } else {
        let countEnter = (worksheet.getCell(`C${index + 2}`).value.match(/\n/g) || []).length || 1
        let countTextLength = worksheet.getCell(`C${index + 2}`).value.length / 30 || 1
        if (countEnter > 1 || countTextLength > 1) {
          let bigNum = countEnter > countTextLength ? countEnter : countTextLength
          worksheet.getRow(index + 2).height = 50 * bigNum
        } else {
          worksheet.getRow(index + 2).height = 40
        }
      }
    }
  })

  for (var i = 2; i < params.contents.length + 2; i++) {
    // 캠페인 명 부분 노란 색으로 배경
    if (i === 2) {
      worksheet.getCell(`B${i}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      worksheet.getCell(`B${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDBDBD' } }
      worksheet.getCell(`C${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } }
    } else {
      worksheet.getCell(`B${i}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      worksheet.getCell(`B${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDBDBD' } }
    }
    worksheet.getCell(`B${i}`).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }
    worksheet.getCell(`B${i}`).font = {
      bold: true
    }
    worksheet.getCell(`C${i}`).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }
    worksheet.getCell(`C${i}`).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
  }
  // addImage
  for (let i = 0; i < imageIndex.length; i++) {
    if (params.contents[imageIndex[i]].id === 'imageId') {
      const base64 = await getBase64FromUrl(params.contents[imageIndex[i]].content)
      const imageName = params.contents[imageIndex[i]].imageName ? params.contents[imageIndex[i]].imageName.trim() : ''
      // 가능한 확장자 ( config 값으로 받아서 list 구성할 예정)
      const reg = /(.*?)\.(jpg|JPG|png|PNG|gif|GIF)$/
      if (imageName.match(reg)) {
        const imageId = workbook.addImage({
          base64: base64,
          extension: imageName.slice(-3).toLowerCase()
        })
        worksheet.addImage(imageId, cell[i])
      }
    } else {
      if (params.contents[imageIndex[i]].content !== null) {
        const imageId = workbook.addImage({
          base64: params.contents[imageIndex[i]].content,
          extension: 'png'
        })
        worksheet.addImage(imageId, cell[i])
      }
    }
  }
  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer])
  let url = window.URL.createObjectURL(blob)

  let elem = document.createElement('a')
  elem.href = url
  elem.download = `${params.fileName}.xlsx`
  elem.click()
  elem.remove()
}

async function downloadExcelRCSSlide(params) {
  const workbook = new ExcelJS.Workbook()
  workbook.addWorksheet(params.sheetName)
  const worksheet = workbook.getWorksheet(params.sheetName)
  worksheet.columns = [
    { header: '', key: '', width: 10 },
    { header: '', key: 'title', width: 30 },
    { header: '', key: 'content', width: 60 }
  ]
  let data = _.cloneDeep(params.contents)
  // contentsData: 캠페인명, array 수가 들어있는 객체 2개 제외한 배열
  let contentsData = data.slice(2)
  let length = data[1].content
  let slideData = []
  // array 수 만큼 자름
  for (let num = 0; num < contentsData.length; num += length) {
    slideData.push(contentsData.slice(num, num + length))
  }
  // 제목 열 추가하려고 만든 배열 : titles
  let titles = ['', '']
  slideData.forEach((item, index) => {
    let elements = ['', '']
    // elements 안에 슬라이드 카드 별 데이터 넣음.
    item.forEach((data, idx) => {
      elements.push(data.content)
      // title 앞에 붙은 숫자 제거
      titles.push(data.title.slice(2))
    })
    worksheet.getColumn(index + 3).values = elements
    worksheet.getColumn(index + 3).width = 55
  })
  // ASCII code 67 ==== 'C'
  for (var i = 2; i < length + 3; i++) {
    if (i === 2) {
      worksheet.getColumn(i).values = titles.slice(0, 7)
      worksheet.getCell(`B${i}`).value = data[0].title
      worksheet.getCell(`C${i}`).value = data[0].content
      worksheet.getCell(`B${i}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      worksheet.getCell(`B${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDBDBD' } }
      worksheet.getCell(`C${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } }
    } else {
      worksheet.getCell(`B${i}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      worksheet.getCell(`B${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDBDBD' } }
    }
    worksheet.getCell(`B${i}`).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }
    worksheet.getCell(`B${i}`).font = {
      bold: true
    }

    for (let num = 0; num < length; num++) {
      worksheet.getCell(`${String.fromCharCode(67 + num)}${i}`).border = {
        top: { style: 'thin', color: { argb: '000000000' } },
        left: { style: 'thin', color: { argb: '000000000' } },
        bottom: { style: 'thin', color: { argb: '000000000' } },
        right: { style: 'thin', color: { argb: '000000000' } }
      }
      worksheet.getCell(`${String.fromCharCode(67 + num)}${i}`).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
      // 이미지일 때는 안하도록 (num === 0 일 때는 이미지이다.)
      if (num !== 0) {
        if (worksheet.getCell(`${String.fromCharCode(67 + num)}${i}:${String.fromCharCode(67 + num)}${i}`).value === null) {
          worksheet.getCell(`${String.fromCharCode(67 + num)}${i}:${String.fromCharCode(67 + num)}${i}`).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
          worksheet.getRow(i).height = 40
        } else {
          let countEnter = (worksheet.getCell(`${String.fromCharCode(67 + num)}${i}:${String.fromCharCode(67 + num)}${i}`).value.match(/\n/g) || []).length || 1
          let countTextLength = worksheet.getCell(`${String.fromCharCode(67 + num)}${i}:${String.fromCharCode(67 + num)}${i}`).value.length / 30 || 1
          if (num !== 0 && (countEnter > 1 || countTextLength > 1)) {
            let bigNum = countEnter > countTextLength ? countEnter : countTextLength
            worksheet.getRow(i).height = 50 * bigNum
            worksheet.getCell(`${String.fromCharCode(67 + num)}${i}:${String.fromCharCode(67 + num)}${i}`).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
          } else {
            worksheet.getCell(`${String.fromCharCode(67 + num)}${i}:${String.fromCharCode(67 + num)}${i}`).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
            worksheet.getRow(i).height = 30
          }
        }
      }
    }
    // 이미지 높이 설정
    worksheet.getRow(3).height = 300
  }
  // 캠페인명 셀 합치기
  worksheet.mergeCells('C2:G2')
  // addImage
  for (let num = 0; num < length; num++) {
    let base64 = await getBase64FromUrl(slideData[num][0].content)
    let imageName = slideData[num][0].imageName ? slideData[num][0].imageName.trim() : ''
    // 가능한 확장자 ( config 값으로 받아서 list 구성할 예정)
    const reg = /(.*?)\.(jpg|JPG|png|PNG|gif|GIF)$/
    if (imageName.match(reg)) {
      let imageId = workbook.addImage({
        base64: base64,
        extension: imageName.slice(-3).toLowerCase()
      })
      worksheet.addImage(imageId, `${String.fromCharCode(67 + num)}3:${String.fromCharCode(67 + num)}3`)
    }
  }
  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer])
  let url = window.URL.createObjectURL(blob)

  let elem = document.createElement('a')
  elem.href = url
  elem.download = `${params.fileName}.xlsx`
  elem.click()
  elem.remove()
}

async function downloadExcelWithStyle(params) {
  const workbook = new ExcelJS.Workbook()
  workbook.addWorksheet(params.sheetName)
  const worksheet = workbook.getWorksheet(params.sheetName)

  worksheet.columns = Object.keys(params.excelHeaders).map((key, index) => {
    return { header: params.excelHeaders[key], key: key, width: params.excelCellStyle[index].wch }
  })

  params.excelData.forEach((data, dataIndex) => {
    let excelData = {}
    Object.keys(params.excelHeaders).forEach(key => {
      if (params.excelDataType[key] === 'numeric') {
        excelData[key] = parseFloat(data[key])
      } else if (params.excelDataType[key] === 'array') {
        excelData[key] = data[key].toString()
      } else {
        excelData[key] = data[key]
      }
    })
    worksheet.addRow(excelData)
  })

  params.excelRowStyle.forEach((style, index) => {
    worksheet.getRow(index + 2).fill = style.fill
  })

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer])
  let url = window.URL.createObjectURL(blob)

  let elem = document.createElement('a')
  elem.href = url
  elem.download = `${params.fileName}.xlsx`
  elem.click()
  elem.remove()
}

const getBase64FromUrl = async url => {
  const data = await fetch(url)
  const blob = await data.blob()
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onloadend = () => {
      const base64data = reader.result
      resolve(base64data)
    }
  })
}

const fillImage = (sheet, image, i) => {
  let info = {}

  if (image.type === 'path') {
    info = {
      filename: image.value,
      extension: image.extension
    }
  } else if (image.type === 'base64') {
    info = {
      base64: image.value,
      extension: image.extension
    }
  }

  const imageId = sheet.workbook.addImage(info)
  sheet.addImage(imageId, {
    tl: { col: image.location.column + i * CS.bundle.cellInterval - 0.9, row: image.location.row - 0.9 },
    ext: { width: CS.bundle.imageWidth, height: CS.bundle.imageHeight }
  })
}

const getCellWithLocation = (sheet, location) => {
  return sheet.getRow(location.row).getCell(location.column)
}

const fillContent = (sheet, product, i) => {
  for (let prop in product) {
    if (prop === 'image') {
      continue
    }

    let baseLocation = product[prop].location
    let location = new Location(baseLocation.row, baseLocation.column + i * CS.bundle.cellInterval)
    let cell = getCellWithLocation(sheet, location)

    cell.value = product[prop].value
  }
}

const checkSize = (sourceRange, targetRange) => {
  if (sourceRange.row !== targetRange.row) {
    return false
  }
  if (sourceRange.column !== targetRange.column) {
    return false
  }
  return true
}

const copyCellValue = (sourceWorkSheet, targetWorkSheet, sourceRange, targetRange) => {
  if (!checkSize(sourceRange, targetRange)) {
    throw Error('복사하려는 셀의 범위가 같지 않습니다.')
  }
  for (let i = 0; i <= sourceRange.height; i++) {
    let sourceRow = sourceRange.cellList[i][0].row
    let targetRow = targetRange.cellList[i][0].row

    for (let j = 0; j <= sourceRange.width; j++) {
      let sourceColumn = sourceRange.cellList[i][j].column
      let targetColumn = targetRange.cellList[i][j].column

      let cell = getCellWithLocation(sourceWorkSheet, new Location(sourceRow, sourceColumn))
      let targetCell = getCellWithLocation(targetWorkSheet, new Location(targetRow, targetColumn))

      targetCell.value = cell.value
    }
  }
}

const copyCellStyle = (sourceWorkSheet, targetWorkSheet, sourceRange, targetRange) => {
  if (!checkSize(sourceRange, targetRange)) {
    throw Error('복사하려는 셀의 범위가 같지 않습니다.')
  }
  for (let i = 0; i <= sourceRange.height; i++) {
    let row = sourceRange.cellList[i][0].row
    let targetRow = targetRange.cellList[i][0].row

    let rowCells = sourceWorkSheet.getRow(row)
    let targetRowCells = targetWorkSheet.getRow(targetRow)

    targetRowCells.height = rowCells.height

    for (let j = 0; j <= sourceRange.width; j++) {
      let column = sourceRange.cellList[i][j].column
      let columnCells = sourceWorkSheet.getColumn(column)
      let cell = rowCells.getCell(column)

      let targetColumn = targetRange.cellList[i][j].column
      let targetColumnCells = targetWorkSheet.getColumn(targetColumn)
      let targetCell = targetRowCells.getCell(targetColumn)

      targetColumnCells.width = columnCells.width
      targetCell.style = cell.style
    }
  }
}
